import { Modal } from 'react-bootstrap'
import { FONTS } from 'src/styles/theme'
import styled from 'styled-components'
import { StyledListItem } from '../AbstractList/ListItem/styled'

export const ResultModal = styled(Modal)`
  .modal-content {
    background-color: #2d2c3c;
    border: none;
    border-radius: 12px;

    .modal-header {
      padding: 0 20px;
      padding-top: 20px;
      border: none;
      font-size: 20px;
      color: #cabebe;
      .close {
        color: white;
      }
    }

    ${StyledListItem} {
      width: auto;
      background: #3e3c4e;
      border: solid 2px #656565b8;
    }
  }

  .noResult {
    text-align: center;
    padding: 20px;
    color: white;
    font-weight: bold;
  }
`

export const SearchStyle = styled.div`
  max-width: 600px;
  margin: 0 auto;
  padding: 20px 10px;

  form {
    width: 100%;
    display: flex;
  }

  input {
    font-family: ${FONTS.primary};
    margin: 0;
    border: none;
    color: white;
  }

  input[type='text'] {
    width: 100%;
    background: #2d2c3c;
    border-top-left-radius: 24px;
    border-bottom-left-radius: 24px;
    padding: 10px 20px;
  }

  input[type='submit'] {
    color: #bfbfbf;
    background: #394554;
    border-top-right-radius: 24px;
    border-bottom-right-radius: 24px;
    padding: 10px 20px;
    border: solid 2px #2d2c3c;
    border-left: none;
  }
`
